import { BillableDeliveryNoteResponse, BillableDeliveryNoteStatus } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { Vue, Component, PropSync } from 'vue-property-decorator'

@Component
export default class BillingModalDeliveryNotesCrudForm extends Vue {
    @PropSync('deliveryNote', { type: Object }) readonly syncedDeliveryNote!: BillableDeliveryNoteResponse

    get deliveryNoteGenerated(): boolean {
        return this.syncedDeliveryNote.status?.code === BillableDeliveryNoteStatus.GENERATED
    }
    get deliveryNoteIssued(): boolean {
        return this.syncedDeliveryNote.status?.code === BillableDeliveryNoteStatus.ISSUED
    }
    get deliveryNoteVerified(): boolean {
        return this.syncedDeliveryNote.status?.code === BillableDeliveryNoteStatus.VERIFIED
    }

    get disabledExternalReference(): boolean {
        return !this.deliveryNoteGenerated && !this.deliveryNoteIssued
    }
}
